/**
 * Layout breakpoint constants shared across applications.
 */

/** Viewport width, in pixels, below which the UI switches to its mobile layout. */
export const MOBILE_BREAKPOINT_PX = 768;
